/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';


/**
 * @summary Restore the authenticated renter's server-owned checkout
 */
export const GetPfcPaymentRecoveryParams = zod.object({
  "publicId": zod.coerce.string().uuid()
})

export const GetPfcPaymentRecoveryResponse = zod.object({
  "tripPublicId": zod.string().optional(),
  "sessionPublicId": zod.string().uuid().optional(),
  "carId": zod.number().optional(),
  "holdUntil": zod.coerce.date().optional(),
  "expired": zod.boolean().optional(),
  "failureReason": zod.union([zod.literal('insufficient_funds'),zod.literal('expired_card'),zod.literal('incorrect_cvc'),zod.literal('authentication_required'),zod.literal('card_declined'),zod.literal(null)]).nullish(),
  "state": zod.record(zod.string(), zod.unknown()).optional().describe('Explicit server-owned checkout input allowlist; never contains Stripe secrets')
})


/**
 * @summary Email a secure authenticated continuation link without charging or extending holds
 */
export const EmailPfcPaymentRecoveryParams = zod.object({
  "publicId": zod.coerce.string().uuid()
})

export const EmailPfcPaymentRecoveryResponse = zod.object({
  "delivered": zod.boolean(),
  "holdUntil": zod.coerce.date()
})


export const GetHostActivityAudienceResponse = zod.object({
  "countries": zod.array(zod.object({
  "country": zod.string(),
  "eligibleHosts": zod.number(),
  "cars": zod.number(),
  "invalidEmailHosts": zod.number(),
  "language": zod.string(),
  "bands": zod.record(zod.string(), zod.number()),
  "excluded": zod.record(zod.string(), zod.number()).optional()
})),
  "totals": zod.object({
  "activeHosts": zod.number(),
  "inactiveHosts": zod.number(),
  "activeCars": zod.number(),
  "inactiveCars": zod.number()
}),
  "blockers": zod.array(zod.string()),
  "reviews": zod.array(zod.object({
  "locale": zod.string(),
  "reviewed": zod.boolean()
}))
})


export const getHostActivityPreviewQueryCountryRegExp = new RegExp('^[A-Z]{2}$');


export const GetHostActivityPreviewQueryParams = zod.object({
  "country": zod.coerce.string().regex(getHostActivityPreviewQueryCountryRegExp),
  "reminder": zod.coerce.boolean().optional()
})

export const GetHostActivityPreviewResponse = zod.object({
  "locale": zod.string(),
  "hostName": zod.string(),
  "fleetCount": zod.number(),
  "subject": zod.string(),
  "emailHtml": zod.string(),
  "pages": zod.object({
  "confirm": zod.string(),
  "pause": zod.string(),
  "sold": zod.string()
}),
  "blockers": zod.array(zod.string())
})


export const testHostActivityEmailBodyCountryRegExp = new RegExp('^[A-Z]{2}$');


export const TestHostActivityEmailBody = zod.object({
  "country": zod.string().regex(testHostActivityEmailBodyCountryRegExp)
})

export const TestHostActivityEmailResponse = zod.object({
  "state": zod.enum(['sent', 'skipped', 'failed', 'ambiguous']),
  "reason": zod.string().optional(),
  "messageId": zod.string().optional()
})


export const planHostActivityBatchBodyCountriesItemRegExp = new RegExp('^[A-Z]{2}$');
export const planHostActivityBatchBodyCountriesMax = 100;



export const PlanHostActivityBatchBody = zod.object({
  "countries": zod.array(zod.string().regex(planHostActivityBatchBodyCountriesItemRegExp)).min(1).max(planHostActivityBatchBodyCountriesMax),
  "band": zod.enum(['recent', 'one_to_two', 'older', 'unknown']).optional(),
  "reminderOf": zod.string().uuid().optional()
})

export const PlanHostActivityBatchResponse = zod.object({
  "id": zod.string().uuid(),
  "count": zod.number(),
  "cars": zod.number(),
  "countries": zod.array(zod.string()),
  "blockers": zod.array(zod.string())
})


export const DispatchHostActivityBatchParams = zod.object({
  "id": zod.coerce.string().uuid()
})

export const dispatchHostActivityBatchBodyExpectedCountMin = 0;



export const DispatchHostActivityBatchBody = zod.object({
  "expectedCount": zod.number().min(dispatchHostActivityBatchBodyExpectedCountMin)
})

export const DispatchHostActivityBatchResponse = zod.object({
  "status": zod.enum(['processing', 'complete']),
  "processed": zod.number(),
  "sent": zod.number(),
  "skipped": zod.number(),
  "failed": zod.number(),
  "ambiguous": zod.number(),
  "pending": zod.number()
})


export const getHostActivityResultsQueryCountryRegExp = new RegExp('^[A-Z]{2}$');


export const GetHostActivityResultsQueryParams = zod.object({
  "country": zod.coerce.string().regex(getHostActivityResultsQueryCountryRegExp).optional(),
  "batch": zod.coerce.string().uuid().optional()
})

export const GetHostActivityResultsResponse = zod.object({
  "batches": zod.array(zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.coerce.date(),
  "sentAt": zod.coerce.date().nullish(),
  "countries": zod.array(zod.string()),
  "count": zod.number(),
  "status": zod.string(),
  "reminderEligible": zod.boolean().nullable()
})),
  "outcomes": zod.array(zod.object({
  "outcome": zod.string(),
  "hosts": zod.number(),
  "cars": zod.number()
})),
  "weekly": zod.array(zod.object({
  "week": zod.coerce.date(),
  "cohort": zod.enum(['active', 'inactive', 'unknown']),
  "period": zod.string(),
  "requests": zod.number(),
  "declined": zod.number(),
  "unanswered": zod.number(),
  "pending": zod.number(),
  "unknown": zod.number(),
  "declinedShare": zod.number().nullish(),
  "unansweredShare": zod.number().nullish(),
  "evidence": zod.string()
})),
  "totals": zod.object({
  "activeHosts": zod.number(),
  "inactiveHosts": zod.number(),
  "activeCars": zod.number(),
  "inactiveCars": zod.number()
}),
  "processing": zod.record(zod.string(), zod.number()),
  "providerRates": zod.object({
  "openRate": zod.number().nullish(),
  "clickRate": zod.number().nullish(),
  "bounceRate": zod.number().nullish()
}),
  "blockers": zod.array(zod.string())
})


export const getPublicHostActivityQueryIdsMax = 1500;



export const GetPublicHostActivityQueryParams = zod.object({
  "ids": zod.coerce.string().max(getPublicHostActivityQueryIdsMax).describe('Up to 100 comma-separated listing IDs')
})

export const GetPublicHostActivityResponse = zod.record(zod.string(), zod.boolean())


export const viewHostActivityActionPathTokenRegExp = new RegExp('^[A-Za-z0-9_-]{43}$');


export const ViewHostActivityActionParams = zod.object({
  "purpose": zod.enum(['confirm', 'pause', 'sold']),
  "token": zod.coerce.string().regex(viewHostActivityActionPathTokenRegExp)
})

export const ViewHostActivityActionResponse = zod.unknown()


export const confirmHostActivityActionPathTokenRegExp = new RegExp('^[A-Za-z0-9_-]{43}$');


export const ConfirmHostActivityActionParams = zod.object({
  "purpose": zod.enum(['confirm', 'pause', 'sold']),
  "token": zod.coerce.string().regex(confirmHostActivityActionPathTokenRegExp)
})


export const confirmHostActivityActionBodyCarIdsMax = 1000;



export const ConfirmHostActivityActionBody = zod.object({
  "human_confirmation": zod.enum(['yes']),
  "car_ids": zod.array(zod.number().min(1)).max(confirmHostActivityActionBodyCarIdsMax).optional()
})

export const ConfirmHostActivityActionResponse = zod.unknown()


export const receiveHostActivityProviderEventsBodyEventsMax = 500;



export const ReceiveHostActivityProviderEventsBody = zod.object({
  "events": zod.array(zod.object({
  "event_id": zod.string(),
  "message_id": zod.string(),
  "event": zod.string(),
  "timestamp": zod.number(),
  "email": zod.string().email(),
  "sending_stream": zod.enum(['bulk']),
  "url": zod.string().optional()
})).max(receiveHostActivityProviderEventsBodyEventsMax)
})

export const ReceiveHostActivityProviderEventsResponse = zod.unknown()


export const GetCheckoutCapabilitiesResponse = zod.object({
  "isAppStoreReviewAccount": zod.boolean()
})


export const GetListingReadinessParams = zod.object({
  "id": zod.coerce.number()
})

export const GetListingReadinessResponse = zod.object({
  "canonicalStatus": zod.string(),
  "online": zod.boolean(),
  "state": zod.enum(['host_action_needed', 'ready_to_submit', 'pending_review', 'review_hold', 'unavailable', 'not_applicable']),
  "canSubmit": zod.boolean(),
  "reasons": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string().optional(),
  "message": zod.string(),
  "responsible": zod.enum(['host', 'administrator', 'provider', 'system']),
  "phase": zod.enum(['submission', 'publication', 'recommendation', 'diagnostic'])
}))
})


export const GetBookingHostHistoryDetailParams = zod.object({
  "publicId": zod.coerce.string()
})

export const GetBookingHostHistoryDetailResponse = zod.object({
  "bookingClock": zod.object({
  "started": zod.boolean().optional(),
  "inProgress": zod.boolean().optional(),
  "pickup": zod.string().nullish(),
  "return": zod.string().nullish(),
  "timezone": zod.string().nullish(),
  "pickupEvidence": zod.enum(['booking_snapshot', 'us_pickup_snapshot', 'legacy_compatibility']).optional(),
  "returnEvidence": zod.enum(['booking_snapshot', 'legacy_compatibility']).optional()
}).optional().describe('Server-owned operation eligibility. Display stamps must not be used as instant evidence.'),
  "hostStripeHistory": zod.object({
  "state": zod.enum(['recorded', 'absent', 'unavailable']),
  "unresolvedRecords": zod.number().optional().describe('Stripe rows withheld because their recorded participant does not match the booking party.'),
  "movements": zod.array(zod.object({
  "kind": zod.enum(['payment', 'refund', 'transfer', 'transfer_reversal']),
  "status": zod.enum(['succeeded', 'failed', 'unknown']),
  "amount": zod.number().nullable(),
  "currency": zod.string().nullable(),
  "recordedAt": zod.string().nullable(),
  "component": zod.enum(['rental', 'insurance', 'deposit', 'other'])
}))
}).optional()
})


/**
 * @summary Internal BAC first-document handoff; production activation disabled
 */
export const observeAcquisitionDocumentRequestHeaderXBacRequestTimeRegExp = new RegExp('^\\d{13}$');
export const observeAcquisitionDocumentRequestHeaderXBacRequestSignatureMax = 43;



export const ObserveAcquisitionDocumentRequestHeader = zod.object({
  "x-bac-request-time": zod.string().regex(observeAcquisitionDocumentRequestHeaderXBacRequestTimeRegExp),
  "x-bac-request-signature": zod.string().max(observeAcquisitionDocumentRequestHeaderXBacRequestSignatureMax)
})

export const observeAcquisitionDocumentRequestBodyHostMax = 255;

export const observeAcquisitionDocumentRequestBodyUrlMax = 8192;

export const observeAcquisitionDocumentRequestBodyReferrerMax = 2048;

export const observeAcquisitionDocumentRequestBodyStateMax = 150;



export const ObserveAcquisitionDocumentRequestBody = zod.object({
  "host": zod.string().max(observeAcquisitionDocumentRequestBodyHostMax),
  "url": zod.string().max(observeAcquisitionDocumentRequestBodyUrlMax),
  "referrer": zod.string().max(observeAcquisitionDocumentRequestBodyReferrerMax),
  "state": zod.string().max(observeAcquisitionDocumentRequestBodyStateMax).nullable()
})

export const observeAcquisitionDocumentRequestResponseStateMax = 150;



export const ObserveAcquisitionDocumentRequestResponse = zod.object({
  "status": zod.string(),
  "state": zod.string().max(observeAcquisitionDocumentRequestResponseStateMax).optional()
})


/**
 * @summary Renew an existing signed BAC request session without inventing an arrival
 */
export const RefreshAcquisitionRequestActivityBody = zod.object({
  "reset": zod.boolean().optional().describe('Clear signed browser state on actual logout')
})

export const RefreshAcquisitionRequestActivityResponse = zod.object({
  "status": zod.string()
})


/**
 * @summary Optional BAC consented acquisition handoff (private uncached response)
 */
export const createAcquisitionSessionBodyUrlMax = 2048;

export const createAcquisitionSessionBodyReferrerMax = 2048;

export const createAcquisitionSessionBodyAcquisitionStateMax = 150;



export const CreateAcquisitionSessionBody = zod.object({
  "analyticsConsent": zod.boolean().optional(),
  "documentEntry": zod.boolean().optional(),
  "marketingConsent": zod.boolean().optional(),
  "surface": zod.enum(['web', 'native']).optional(),
  "url": zod.string().max(createAcquisitionSessionBodyUrlMax).optional(),
  "referrer": zod.string().max(createAcquisitionSessionBodyReferrerMax).optional(),
  "acquisitionState": zod.string().max(createAcquisitionSessionBodyAcquisitionStateMax).optional()
})

export const CreateAcquisitionSessionResponse = zod.record(zod.string(), zod.unknown())


/**
 * @summary Bind consented signed state to authenticated renter
 */
export const bindAcquisitionSessionBodyAcquisitionStateMax = 150;



export const BindAcquisitionSessionBody = zod.object({
  "acquisitionConsent": zod.boolean().optional(),
  "acquisitionState": zod.string().max(bindAcquisitionSessionBodyAcquisitionStateMax).optional()
})

export const BindAcquisitionSessionResponse = zod.record(zod.string(), zod.unknown())


export const getPublicCarCanonicalsQueryIdsMax = 2000;


export const getPublicCarCanonicalsQueryIdsRegExp = new RegExp('^[1-9][0-9]*(,[1-9][0-9]*)*$');


export const GetPublicCarCanonicalsQueryParams = zod.object({
  "ids": zod.coerce.string().max(getPublicCarCanonicalsQueryIdsMax).regex(getPublicCarCanonicalsQueryIdsRegExp)
})

export const GetPublicCarCanonicalsResponse = zod.object({
  "cars": zod.array(zod.object({
  "id": zod.number(),
  "publicCanonical": zod.object({
  "off": zod.object({
  "path": zod.string().nullable(),
  "url": zod.string().nullable(),
  "legacyUrl": zod.string().nullish(),
  "reason": zod.string().optional(),
  "kind": zod.string().optional()
}),
  "on": zod.object({
  "path": zod.string().nullable(),
  "url": zod.string().nullable(),
  "legacyUrl": zod.string().nullish(),
  "reason": zod.string().optional(),
  "kind": zod.string().optional()
})
}),
  "canonicalUrl": zod.string().nullable(),
  "canonicalPath": zod.string().nullable()
}))
})


export const getPublicPageCanonicalQueryPathMax = 2048;


export const getPublicPageCanonicalQueryPathRegExp = new RegExp('^/[^?#]*$');


export const GetPublicPageCanonicalQueryParams = zod.object({
  "path": zod.coerce.string().max(getPublicPageCanonicalQueryPathMax).regex(getPublicPageCanonicalQueryPathRegExp)
})

export const GetPublicPageCanonicalResponse = zod.object({
  "publicCanonicalRoute": zod.object({
  "off": zod.object({
  "path": zod.string().nullable(),
  "url": zod.string().nullable(),
  "legacyUrl": zod.string().nullish(),
  "reason": zod.string().optional(),
  "kind": zod.string().optional()
}),
  "on": zod.object({
  "path": zod.string().nullable(),
  "url": zod.string().nullable(),
  "legacyUrl": zod.string().nullish(),
  "reason": zod.string().optional(),
  "kind": zod.string().optional()
})
}).and(zod.object({
  "pathname": zod.string()
}))
})


/**
 * @summary Read-only accepted account driving trips
 */
export const GetAccountDrivingTripsResponseItem = zod.object({
  "key": zod.string(),
  "assignmentId": zod.string(),
  "car": zod.object({
  "name": zod.string(),
  "imageUrl": zod.string().nullable()
}),
  "rentalType": zod.string(),
  "startAt": zod.string(),
  "endAt": zod.string(),
  "timezone": zod.string().nullable(),
  "timesCaptured": zod.boolean().nullable(),
  "approval": zod.union([zod.literal('approved_to_drive'),zod.literal(null)]).nullable(),
  "progress": zod.object({
  "acceptance": zod.enum(['accepted']),
  "reservation": zod.enum(['awaiting_host', 'confirmed', 'pending']),
  "state": zod.enum(['checks_needed', 'checks_in_progress', 'preparing', 'licence_complete', 'driving_record_pending', 'in_review', 'retryable', 'blocked', 'unknown', 'not_approved', 'approved', 'deadline_passed']),
  "nextAction": zod.union([zod.literal('start'),zod.literal('continue'),zod.literal('retry'),zod.literal('help'),zod.literal(null)]).nullable(),
  "deadlineAt": zod.string().nullable()
})
})
export const GetAccountDrivingTripsResponse = zod.array(GetAccountDrivingTripsResponseItem)


/**
 * @summary Provider-free assessment of an authenticated accepted assignment
 */
export const GetAccountDrivingAssessmentParams = zod.object({
  "assignmentId": zod.coerce.string()
})

export const GetAccountDrivingAssessmentResponse = zod.object({
  "acceptance": zod.enum(['accepted']),
  "reservation": zod.enum(['awaiting_host', 'confirmed', 'pending']),
  "state": zod.enum(['checks_needed', 'checks_in_progress', 'preparing', 'licence_complete', 'driving_record_pending', 'in_review', 'retryable', 'blocked', 'unknown', 'not_approved', 'approved', 'deadline_passed']),
  "nextAction": zod.union([zod.literal('start'),zod.literal('continue'),zod.literal('retry'),zod.literal('help'),zod.literal(null)]).nullable(),
  "deadlineAt": zod.string().nullable()
})


/**
 * @summary Explicit assignment-bound start or continuation without invitation tokens
 */
export const ContinueAccountDrivingChecksParams = zod.object({
  "assignmentId": zod.coerce.string()
})

export const ContinueAccountDrivingChecksBody = zod.object({
  "action": zod.enum(['start', 'continue', 'retry'])
})

export const ContinueAccountDrivingChecksResponse = zod.object({
  "verification_status": zod.enum(['ready', 'preparing', 'retryable', 'unavailable', 'complete']),
  "verification_url": zod.string().nullable(),
  "verification_session_token": zod.string().nullable(),
  "verification_start_error": zod.string().nullish()
})


/**
 * Public project identifiers only; development requires matching effective auth, catalogue and direct database targets. Never use hostname naming as environment proof.
 * @summary Effective mobile backend environment identity
 */
export const GetMobileBackendIdentityResponse = zod.object({
  "version": zod.literal(1),
  "environment": zod.enum(['development', 'production', 'inconsistent']),
  "authProjectRef": zod.string().nullable(),
  "databaseProjectRef": zod.string().nullable(),
  "catalogueProjectRef": zod.string().nullable(),
  "writable": zod.boolean()
})


/**
 * Returns server health status
 * @summary Health check
 */
export const HealthCheckQueryParams = zod.object({
  "deadline_contract": zod.enum(['1']).optional().describe('Opt-in read-only deadline release and policy evidence')
})

export const HealthCheckResponse = zod.object({
  "status": zod.string(),
  "deadlineContract": zod.object({
  "version": zod.string(),
  "bundleSha256": zod.string().nullable(),
  "quoteSourceSha256": zod.string().nullable(),
  "bootTime": zod.string(),
  "environment": zod.string(),
  "databaseMode": zod.string(),
  "policyEnabled": zod.boolean()
}).optional()
})


/**
 * @summary Resolve a public landing page by its requested path
 */
export const getLandingPageByPathQueryCountryCodeRegExp = new RegExp('^[A-Za-z]{2}$');
export const getLandingPageByPathQueryLocaleRegExp = new RegExp('^[a-z]{2}(?:-[a-z]{2})?$');


export const GetLandingPageByPathQueryParams = zod.object({
  "path": zod.coerce.string(),
  "probe": zod.enum(['1']).optional(),
  "brand": zod.enum(['bookaclassic', 'driveshare']).optional(),
  "country_code": zod.coerce.string().regex(getLandingPageByPathQueryCountryCodeRegExp).optional(),
  "locale": zod.coerce.string().regex(getLandingPageByPathQueryLocaleRegExp).optional()
})

export const getLandingPageByPathResponsePinnedInventoryOneSourceCountMin = 0;

export const getLandingPageByPathResponsePinnedInventoryOneUnavailableCountMin = 0;

export const getLandingPageByPathResponsePinnedInventoryOneCarsItemImagesItemWidthMultipleOf = 1;

export const getLandingPageByPathResponsePinnedInventoryOneCarsItemImagesItemHeightMultipleOf = 1;

export const getLandingPageByPathResponseFixedInventoryCohortsItemCarsItemImagesItemWidthMultipleOf = 1;

export const getLandingPageByPathResponseFixedInventoryCohortsItemCarsItemImagesItemHeightMultipleOf = 1;

export const getLandingPageByPathResponseFixedInventorySourcePinnedInventoryOneSourceCountMin = 0;

export const getLandingPageByPathResponseFixedInventorySourcePinnedInventoryOneUnavailableCountMin = 0;

export const getLandingPageByPathResponseFixedInventorySourcePinnedInventoryOneCarsItemImagesItemWidthMultipleOf = 1;

export const getLandingPageByPathResponseFixedInventorySourcePinnedInventoryOneCarsItemImagesItemHeightMultipleOf = 1;



export const GetLandingPageByPathResponse = zod.object({
  "page": zod.record(zod.string(), zod.unknown()),
  "pinnedInventory": zod.union([zod.object({
  "state": zod.enum(['ready', 'source_unavailable', 'inventory_unavailable']),
  "sourcePath": zod.string(),
  "capturedAt": zod.string().nullable(),
  "sourceCount": zod.number().min(getLandingPageByPathResponsePinnedInventoryOneSourceCountMin),
  "unavailableCount": zod.number().min(getLandingPageByPathResponsePinnedInventoryOneUnavailableCountMin),
  "cars": zod.array(zod.object({
  "id": zod.number(),
  "slug": zod.string(),
  "platformOrigin": zod.string().nullish(),
  "legacySlug": zod.string().nullish(),
  "make": zod.string(),
  "model": zod.string(),
  "year": zod.number(),
  "city": zod.string().nullable(),
  "state": zod.string().nullable(),
  "priceDriving": zod.number().nullish(),
  "priceEvent": zod.number().nullish(),
  "chauffeurMinPrice": zod.number().nullish(),
  "eventMinPrice": zod.number().nullish(),
  "eventHourlyRate": zod.number().nullish(),
  "chauffeuredHourlyRate": zod.number().nullish(),
  "minimumPrice": zod.number().nullish(),
  "primaryImageUrl": zod.string().nullish(),
  "primaryImageCdnThumbnail": zod.string().nullish(),
  "primaryImageCdnMedium": zod.string().nullish(),
  "primaryImageCdnFull": zod.string().nullish(),
  "images": zod.array(zod.object({
  "url": zod.string().nullish(),
  "cdnThumbnail": zod.string().nullish(),
  "cdnMedium": zod.string().nullish(),
  "cdnFull": zod.string().nullish(),
  "width": zod.number().min(1).multipleOf(getLandingPageByPathResponsePinnedInventoryOneCarsItemImagesItemWidthMultipleOf).nullish(),
  "height": zod.number().min(1).multipleOf(getLandingPageByPathResponsePinnedInventoryOneCarsItemImagesItemHeightMultipleOf).nullish()
})).optional(),
  "rentalDrivingActive": zod.boolean().optional(),
  "rentalChauffeurActive": zod.boolean().optional(),
  "rentalEventActive": zod.boolean().optional(),
  "totalScore": zod.number().nullish(),
  "featured": zod.boolean().optional(),
  "reviewsRating": zod.number().nullish(),
  "reviewsCount": zod.number().nullish(),
  "transmission": zod.string().nullish(),
  "passengers": zod.number().nullish(),
  "currencyCode": zod.string(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "countryCode": zod.string().nullish(),
  "ownerProTier": zod.string().nullish(),
  "instantBook": zod.boolean().optional(),
  "createdAt": zod.string().nullish()
}).describe('Public car-card DTO shared with cars\/search and the frontend CarCard.'))
}),zod.null()]).optional(),
  "fixedInventory": zod.object({
  "state": zod.enum(['ready', 'unavailable', 'not_applicable']),
  "generationId": zod.string().nullable(),
  "generatedAt": zod.string().nullable(),
  "nextRefreshAt": zod.string().nullable(),
  "path": zod.string(),
  "countryCode": zod.string().nullable(),
  "locale": zod.string().nullable(),
  "brand": zod.enum(['bookaclassic', 'driveshare']),
  "defaultCohort": zod.string(),
  "cohorts": zod.array(zod.object({
  "key": zod.string(),
  "scope": zod.object({
  "city": zod.string().nullish(),
  "region": zod.string().nullish(),
  "location": zod.string().nullish(),
  "make": zod.string().nullish(),
  "model": zod.string().nullish(),
  "category": zod.string().nullish(),
  "occasion": zod.string().nullish(),
  "carTypes": zod.array(zod.string()).optional(),
  "eras": zod.array(zod.string()).optional(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish()
}).optional(),
  "cars": zod.array(zod.object({
  "id": zod.number(),
  "slug": zod.string(),
  "platformOrigin": zod.string().nullish(),
  "legacySlug": zod.string().nullish(),
  "make": zod.string(),
  "model": zod.string(),
  "year": zod.number(),
  "city": zod.string().nullable(),
  "state": zod.string().nullable(),
  "priceDriving": zod.number().nullish(),
  "priceEvent": zod.number().nullish(),
  "chauffeurMinPrice": zod.number().nullish(),
  "eventMinPrice": zod.number().nullish(),
  "eventHourlyRate": zod.number().nullish(),
  "chauffeuredHourlyRate": zod.number().nullish(),
  "minimumPrice": zod.number().nullish(),
  "primaryImageUrl": zod.string().nullish(),
  "primaryImageCdnThumbnail": zod.string().nullish(),
  "primaryImageCdnMedium": zod.string().nullish(),
  "primaryImageCdnFull": zod.string().nullish(),
  "images": zod.array(zod.object({
  "url": zod.string().nullish(),
  "cdnThumbnail": zod.string().nullish(),
  "cdnMedium": zod.string().nullish(),
  "cdnFull": zod.string().nullish(),
  "width": zod.number().min(1).multipleOf(getLandingPageByPathResponseFixedInventoryCohortsItemCarsItemImagesItemWidthMultipleOf).nullish(),
  "height": zod.number().min(1).multipleOf(getLandingPageByPathResponseFixedInventoryCohortsItemCarsItemImagesItemHeightMultipleOf).nullish()
})).optional(),
  "rentalDrivingActive": zod.boolean().optional(),
  "rentalChauffeurActive": zod.boolean().optional(),
  "rentalEventActive": zod.boolean().optional(),
  "totalScore": zod.number().nullish(),
  "featured": zod.boolean().optional(),
  "reviewsRating": zod.number().nullish(),
  "reviewsCount": zod.number().nullish(),
  "transmission": zod.string().nullish(),
  "passengers": zod.number().nullish(),
  "currencyCode": zod.string(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "countryCode": zod.string().nullish(),
  "ownerProTier": zod.string().nullish(),
  "instantBook": zod.boolean().optional(),
  "createdAt": zod.string().nullish()
}).describe('Public car-card DTO shared with cars\/search and the frontend CarCard.')),
  "orderedCarIds": zod.array(zod.number()),
  "selectionStrategy": zod.string(),
  "fallback": zod.boolean(),
  "fallbackLabel": zod.string().nullable()
})),
  "sourcePinnedInventory": zod.union([zod.object({
  "state": zod.enum(['ready', 'source_unavailable', 'inventory_unavailable']),
  "sourcePath": zod.string(),
  "capturedAt": zod.string().nullable(),
  "sourceCount": zod.number().min(getLandingPageByPathResponseFixedInventorySourcePinnedInventoryOneSourceCountMin),
  "unavailableCount": zod.number().min(getLandingPageByPathResponseFixedInventorySourcePinnedInventoryOneUnavailableCountMin),
  "cars": zod.array(zod.object({
  "id": zod.number(),
  "slug": zod.string(),
  "platformOrigin": zod.string().nullish(),
  "legacySlug": zod.string().nullish(),
  "make": zod.string(),
  "model": zod.string(),
  "year": zod.number(),
  "city": zod.string().nullable(),
  "state": zod.string().nullable(),
  "priceDriving": zod.number().nullish(),
  "priceEvent": zod.number().nullish(),
  "chauffeurMinPrice": zod.number().nullish(),
  "eventMinPrice": zod.number().nullish(),
  "eventHourlyRate": zod.number().nullish(),
  "chauffeuredHourlyRate": zod.number().nullish(),
  "minimumPrice": zod.number().nullish(),
  "primaryImageUrl": zod.string().nullish(),
  "primaryImageCdnThumbnail": zod.string().nullish(),
  "primaryImageCdnMedium": zod.string().nullish(),
  "primaryImageCdnFull": zod.string().nullish(),
  "images": zod.array(zod.object({
  "url": zod.string().nullish(),
  "cdnThumbnail": zod.string().nullish(),
  "cdnMedium": zod.string().nullish(),
  "cdnFull": zod.string().nullish(),
  "width": zod.number().min(1).multipleOf(getLandingPageByPathResponseFixedInventorySourcePinnedInventoryOneCarsItemImagesItemWidthMultipleOf).nullish(),
  "height": zod.number().min(1).multipleOf(getLandingPageByPathResponseFixedInventorySourcePinnedInventoryOneCarsItemImagesItemHeightMultipleOf).nullish()
})).optional(),
  "rentalDrivingActive": zod.boolean().optional(),
  "rentalChauffeurActive": zod.boolean().optional(),
  "rentalEventActive": zod.boolean().optional(),
  "totalScore": zod.number().nullish(),
  "featured": zod.boolean().optional(),
  "reviewsRating": zod.number().nullish(),
  "reviewsCount": zod.number().nullish(),
  "transmission": zod.string().nullish(),
  "passengers": zod.number().nullish(),
  "currencyCode": zod.string(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "countryCode": zod.string().nullish(),
  "ownerProTier": zod.string().nullish(),
  "instantBook": zod.boolean().optional(),
  "createdAt": zod.string().nullish()
}).describe('Public car-card DTO shared with cars\/search and the frontend CarCard.'))
}),zod.null()]).optional()
}).optional(),
  "landingEvidence": zod.record(zod.string(), zod.unknown()).optional(),
  "richResultEvidence": zod.record(zod.string(), zod.unknown()).optional()
})


/**
 * Returns currency formatting rules, cancellation policies, and verification requirements
 * @summary Get platform configuration
 */
export const GetPlatformConfigResponse = zod.object({
  "currency": zod.object({
  "symbols": zod.record(zod.string(), zod.string()),
  "defaultCode": zod.string(),
  "decimalHandling": zod.string()
}),
  "cancellationPolicies": zod.array(zod.object({
  "type": zod.string(),
  "label": zod.string(),
  "description": zod.string(),
  "rules": zod.array(zod.string()),
  "refundPercentages": zod.record(zod.string(), zod.number()).optional(),
  "discountPercent": zod.number()
})),
  "verificationRequirements": zod.object({
  "booking": zod.object({
  "email_verified": zod.boolean(),
  "phone_verified": zod.boolean()
}),
  "listing": zod.object({
  "email_verified": zod.boolean()
})
}),
  "serviceFeePercent": zod.number()
})


/**
 * Returns the same immutable, ordered car-card cohorts used by landing-page rendering. Search results and booking availability remain live.
 * @summary Get the published daily car selection for a marketing landing page
 */
export const GetDailyLandingInventoryQueryParams = zod.object({
  "path": zod.coerce.string(),
  "country_code": zod.coerce.string().optional(),
  "locale": zod.coerce.string().optional(),
  "brand": zod.enum(['bookaclassic', 'driveshare']).optional()
})

export const getDailyLandingInventoryResponseCohortsItemCarsItemImagesItemWidthMultipleOf = 1;

export const getDailyLandingInventoryResponseCohortsItemCarsItemImagesItemHeightMultipleOf = 1;

export const getDailyLandingInventoryResponseSourcePinnedInventoryOneSourceCountMin = 0;

export const getDailyLandingInventoryResponseSourcePinnedInventoryOneUnavailableCountMin = 0;

export const getDailyLandingInventoryResponseSourcePinnedInventoryOneCarsItemImagesItemWidthMultipleOf = 1;

export const getDailyLandingInventoryResponseSourcePinnedInventoryOneCarsItemImagesItemHeightMultipleOf = 1;



export const GetDailyLandingInventoryResponse = zod.object({
  "state": zod.enum(['ready', 'unavailable', 'not_applicable']),
  "generationId": zod.string().nullable(),
  "generatedAt": zod.string().nullable(),
  "nextRefreshAt": zod.string().nullable(),
  "path": zod.string(),
  "countryCode": zod.string().nullable(),
  "locale": zod.string().nullable(),
  "brand": zod.enum(['bookaclassic', 'driveshare']),
  "defaultCohort": zod.string(),
  "cohorts": zod.array(zod.object({
  "key": zod.string(),
  "scope": zod.object({
  "city": zod.string().nullish(),
  "region": zod.string().nullish(),
  "location": zod.string().nullish(),
  "make": zod.string().nullish(),
  "model": zod.string().nullish(),
  "category": zod.string().nullish(),
  "occasion": zod.string().nullish(),
  "carTypes": zod.array(zod.string()).optional(),
  "eras": zod.array(zod.string()).optional(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish()
}).optional(),
  "cars": zod.array(zod.object({
  "id": zod.number(),
  "slug": zod.string(),
  "platformOrigin": zod.string().nullish(),
  "legacySlug": zod.string().nullish(),
  "make": zod.string(),
  "model": zod.string(),
  "year": zod.number(),
  "city": zod.string().nullable(),
  "state": zod.string().nullable(),
  "priceDriving": zod.number().nullish(),
  "priceEvent": zod.number().nullish(),
  "chauffeurMinPrice": zod.number().nullish(),
  "eventMinPrice": zod.number().nullish(),
  "eventHourlyRate": zod.number().nullish(),
  "chauffeuredHourlyRate": zod.number().nullish(),
  "minimumPrice": zod.number().nullish(),
  "primaryImageUrl": zod.string().nullish(),
  "primaryImageCdnThumbnail": zod.string().nullish(),
  "primaryImageCdnMedium": zod.string().nullish(),
  "primaryImageCdnFull": zod.string().nullish(),
  "images": zod.array(zod.object({
  "url": zod.string().nullish(),
  "cdnThumbnail": zod.string().nullish(),
  "cdnMedium": zod.string().nullish(),
  "cdnFull": zod.string().nullish(),
  "width": zod.number().min(1).multipleOf(getDailyLandingInventoryResponseCohortsItemCarsItemImagesItemWidthMultipleOf).nullish(),
  "height": zod.number().min(1).multipleOf(getDailyLandingInventoryResponseCohortsItemCarsItemImagesItemHeightMultipleOf).nullish()
})).optional(),
  "rentalDrivingActive": zod.boolean().optional(),
  "rentalChauffeurActive": zod.boolean().optional(),
  "rentalEventActive": zod.boolean().optional(),
  "totalScore": zod.number().nullish(),
  "featured": zod.boolean().optional(),
  "reviewsRating": zod.number().nullish(),
  "reviewsCount": zod.number().nullish(),
  "transmission": zod.string().nullish(),
  "passengers": zod.number().nullish(),
  "currencyCode": zod.string(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "countryCode": zod.string().nullish(),
  "ownerProTier": zod.string().nullish(),
  "instantBook": zod.boolean().optional(),
  "createdAt": zod.string().nullish()
}).describe('Public car-card DTO shared with cars\/search and the frontend CarCard.')),
  "orderedCarIds": zod.array(zod.number()),
  "selectionStrategy": zod.string(),
  "fallback": zod.boolean(),
  "fallbackLabel": zod.string().nullable()
})),
  "sourcePinnedInventory": zod.union([zod.object({
  "state": zod.enum(['ready', 'source_unavailable', 'inventory_unavailable']),
  "sourcePath": zod.string(),
  "capturedAt": zod.string().nullable(),
  "sourceCount": zod.number().min(getDailyLandingInventoryResponseSourcePinnedInventoryOneSourceCountMin),
  "unavailableCount": zod.number().min(getDailyLandingInventoryResponseSourcePinnedInventoryOneUnavailableCountMin),
  "cars": zod.array(zod.object({
  "id": zod.number(),
  "slug": zod.string(),
  "platformOrigin": zod.string().nullish(),
  "legacySlug": zod.string().nullish(),
  "make": zod.string(),
  "model": zod.string(),
  "year": zod.number(),
  "city": zod.string().nullable(),
  "state": zod.string().nullable(),
  "priceDriving": zod.number().nullish(),
  "priceEvent": zod.number().nullish(),
  "chauffeurMinPrice": zod.number().nullish(),
  "eventMinPrice": zod.number().nullish(),
  "eventHourlyRate": zod.number().nullish(),
  "chauffeuredHourlyRate": zod.number().nullish(),
  "minimumPrice": zod.number().nullish(),
  "primaryImageUrl": zod.string().nullish(),
  "primaryImageCdnThumbnail": zod.string().nullish(),
  "primaryImageCdnMedium": zod.string().nullish(),
  "primaryImageCdnFull": zod.string().nullish(),
  "images": zod.array(zod.object({
  "url": zod.string().nullish(),
  "cdnThumbnail": zod.string().nullish(),
  "cdnMedium": zod.string().nullish(),
  "cdnFull": zod.string().nullish(),
  "width": zod.number().min(1).multipleOf(getDailyLandingInventoryResponseSourcePinnedInventoryOneCarsItemImagesItemWidthMultipleOf).nullish(),
  "height": zod.number().min(1).multipleOf(getDailyLandingInventoryResponseSourcePinnedInventoryOneCarsItemImagesItemHeightMultipleOf).nullish()
})).optional(),
  "rentalDrivingActive": zod.boolean().optional(),
  "rentalChauffeurActive": zod.boolean().optional(),
  "rentalEventActive": zod.boolean().optional(),
  "totalScore": zod.number().nullish(),
  "featured": zod.boolean().optional(),
  "reviewsRating": zod.number().nullish(),
  "reviewsCount": zod.number().nullish(),
  "transmission": zod.string().nullish(),
  "passengers": zod.number().nullish(),
  "currencyCode": zod.string(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "countryCode": zod.string().nullish(),
  "ownerProTier": zod.string().nullish(),
  "instantBook": zod.boolean().optional(),
  "createdAt": zod.string().nullish()
}).describe('Public car-card DTO shared with cars\/search and the frontend CarCard.'))
}),zod.null()]).optional()
})


/**
 * Calculates pricing for a car rental including fees, insurance, and cancellation discounts
 * @summary Get a booking price quote
 */
export const getBookingQuoteQueryRentalTypeDefault = `driving`;
export const getBookingQuoteQueryCancellationPolicyDefault = `flexible`;

export const GetBookingQuoteQueryParams = zod.object({
  "car_id": zod.coerce.number(),
  "date_from": zod.date(),
  "date_to": zod.date(),
  "rental_type": zod.enum(['driving', 'chauffeured', 'event']).default(getBookingQuoteQueryRentalTypeDefault),
  "insurance_package_id": zod.coerce.number().optional(),
  "probe_token": zod.coerce.string().optional().describe('Host availability consent; effective only for the authenticated matching renter and terms.'),
  "cancellation_policy": zod.enum(['flexible', 'non-refundable']).default(getBookingQuoteQueryCancellationPolicyDefault),
  "delivery_distance": zod.coerce.number().optional()
})

export const GetBookingQuoteResponse = zod.object({
  "carId": zod.number(),
  "rentalType": zod.string(),
  "dateFrom": zod.coerce.date(),
  "dateTo": zod.coerce.date(),
  "numDays": zod.number(),
  "baseRate": zod.number(),
  "rentalFee": zod.number(),
  "baseRentalFee": zod.number().optional(),
  "serviceFee": zod.number(),
  "serviceFeePercent": zod.number(),
  "insuranceFee": zod.number(),
  "insuranceDailyRate": zod.number(),
  "insurancePackageId": zod.number().nullish(),
  "insurancePackageName": zod.string().nullish(),
  "cancellationPolicy": zod.string(),
  "refundableSurcharge": zod.number(),
  "refundableSurchargePercent": zod.number(),
  "policyTotals": zod.object({
  "nonRefundable": zod.object({
  "paymentDue": zod.number(),
  "platformPaymentDue": zod.number()
}),
  "flexible": zod.object({
  "paymentDue": zod.number(),
  "platformPaymentDue": zod.number()
})
}),
  "cancellationPolicyDetails": zod.object({
  "type": zod.string(),
  "label": zod.string(),
  "description": zod.string(),
  "rules": zod.array(zod.string()),
  "discountPercent": zod.number(),
  "surchargePercent": zod.number().optional()
}),
  "deliveryFee": zod.number(),
  "deposit": zod.number(),
  "paymentDue": zod.number(),
  "ownerEarn": zod.number(),
  "instantBooking": zod.boolean(),
  "currency": zod.string()
})


/**
 * Returns all listing drafts for the authenticated user
 * @summary List listing drafts
 */
export const ListListingDraftsResponse = zod.object({
  "drafts": zod.array(zod.object({
  "id": zod.string(),
  "user_id": zod.string(),
  "data": zod.record(zod.string(), zod.unknown()),
  "step": zod.number(),
  "created_at": zod.coerce.date(),
  "updated_at": zod.coerce.date()
}))
})


/**
 * Saves a new listing wizard draft for the authenticated user
 * @summary Create a listing draft
 */
export const CreateListingDraftBody = zod.object({
  "data": zod.record(zod.string(), zod.unknown()),
  "step": zod.number().optional()
})

export const CreateListingDraftResponse = zod.object({
  "draft": zod.object({
  "id": zod.string(),
  "user_id": zod.string(),
  "data": zod.record(zod.string(), zod.unknown()),
  "step": zod.number(),
  "created_at": zod.coerce.date(),
  "updated_at": zod.coerce.date()
})
})


/**
 * Returns a specific listing draft by ID for the authenticated user
 * @summary Get a listing draft
 */
export const GetListingDraftParams = zod.object({
  "id": zod.coerce.string()
})

export const GetListingDraftResponse = zod.object({
  "draft": zod.object({
  "id": zod.string(),
  "user_id": zod.string(),
  "data": zod.record(zod.string(), zod.unknown()),
  "step": zod.number(),
  "created_at": zod.coerce.date(),
  "updated_at": zod.coerce.date()
})
})


/**
 * Updates an existing listing draft
 * @summary Update a listing draft
 */
export const UpdateListingDraftParams = zod.object({
  "id": zod.coerce.string()
})

export const UpdateListingDraftBody = zod.object({
  "data": zod.record(zod.string(), zod.unknown()),
  "step": zod.number().optional()
})

export const UpdateListingDraftResponse = zod.object({
  "draft": zod.object({
  "id": zod.string(),
  "user_id": zod.string(),
  "data": zod.record(zod.string(), zod.unknown()),
  "step": zod.number(),
  "created_at": zod.coerce.date(),
  "updated_at": zod.coerce.date()
})
})


/**
 * Deletes a specific listing draft
 * @summary Delete a listing draft
 */
export const DeleteListingDraftParams = zod.object({
  "id": zod.coerce.string()
})

export const DeleteListingDraftResponse = zod.object({
  "success": zod.boolean()
})


/**
 * Requires the opaque HttpOnly guest cookie or a registered payer token; never looks up an account by an email address.
 * @summary Read this browser's private guest checkout details
 */
export const GetGuestCheckoutResponse = zod.object({
  "guest": zod.object({
  "id": zod.string().uuid(),
  "flowId": zod.string().uuid(),
  "userId": zod.number(),
  "email": zod.string().email(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "createdAt": zod.coerce.date().optional(),
  "expiresAt": zod.coerce.date().optional(),
  "claimed": zod.boolean(),
  "csrfToken": zod.string()
}).nullish()
})


/**
 * Does not verify an email, adopt an existing account, create a booking or initiate payment. Existing guest cookies require the matching CSRF header.
 * @summary Provision an isolated checkout payer session
 */
export const StartGuestCheckoutHeader = zod.object({
  "X-Checkout-Guest-CSRF": zod.string().optional().describe('Required when a guest cookie is present; obtained only from the cookie-owned details response.')
})


export const startGuestCheckoutBodyRecoveryHoursExclusiveMin = 0;


export const startGuestCheckoutBodyRecoveryOccasionMax = 64;


export const startGuestCheckoutBodyRecoveryOccasionRegExp = new RegExp('^[a-zA-Z0-9_-]+$');
export const startGuestCheckoutBodyFirstNameMax = 100;

export const startGuestCheckoutBodyLastNameMax = 100;



export const StartGuestCheckoutBody = zod.object({
  "recovery": zod.object({
  "carId": zod.number().min(1),
  "dateFrom": zod.coerce.date(),
  "dateTo": zod.coerce.date(),
  "rentalType": zod.enum(['driving', 'chauffeured', 'event']),
  "hours": zod.number().gt(startGuestCheckoutBodyRecoveryHoursExclusiveMin).optional(),
  "insurancePackageId": zod.number().min(1).optional(),
  "occasion": zod.string().max(startGuestCheckoutBodyRecoveryOccasionMax).regex(startGuestCheckoutBodyRecoveryOccasionRegExp).optional()
}).optional().describe('Saved booking selections for transactional checkout recovery. Never grants access to an existing account or changes marketing consent.'),
  "flowId": zod.string().uuid(),
  "firstName": zod.string().min(1).max(startGuestCheckoutBodyFirstNameMax),
  "lastName": zod.string().min(1).max(startGuestCheckoutBodyLastNameMax),
  "email": zod.string().email(),
  "turnstileToken": zod.string().nullish().describe('Single-use bot-protection proof when the existing auth protection is enabled. Never stored with guest details.')
})

export const StartGuestCheckoutResponse = zod.object({
  "guest": zod.object({
  "id": zod.string().uuid(),
  "flowId": zod.string().uuid(),
  "userId": zod.number(),
  "email": zod.string().email(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "createdAt": zod.coerce.date().optional(),
  "expiresAt": zod.coerce.date().optional(),
  "claimed": zod.boolean(),
  "csrfToken": zod.string()
}),
  "session": zod.object({
  "access_token": zod.string(),
  "refresh_token": zod.string(),
  "token_type": zod.string(),
  "expires_in": zod.number(),
  "expires_at": zod.number().optional(),
  "user": zod.record(zod.string(), zod.unknown())
}).describe('Provider session material for the SDK only. Never persist in checkout drafts, URLs, logs or analytics.')
})


/**
 * @summary Update this guest payer's unverified contact details
 */
export const UpdateGuestCheckoutDetailsHeader = zod.object({
  "X-Checkout-Guest-CSRF": zod.string().optional().describe('Required when a guest cookie is present; obtained only from the cookie-owned details response.')
})


export const updateGuestCheckoutDetailsBodyRecoveryHoursExclusiveMin = 0;


export const updateGuestCheckoutDetailsBodyRecoveryOccasionMax = 64;


export const updateGuestCheckoutDetailsBodyRecoveryOccasionRegExp = new RegExp('^[a-zA-Z0-9_-]+$');
export const updateGuestCheckoutDetailsBodyFirstNameMax = 100;

export const updateGuestCheckoutDetailsBodyLastNameMax = 100;



export const UpdateGuestCheckoutDetailsBody = zod.object({
  "recovery": zod.object({
  "carId": zod.number().min(1),
  "dateFrom": zod.coerce.date(),
  "dateTo": zod.coerce.date(),
  "rentalType": zod.enum(['driving', 'chauffeured', 'event']),
  "hours": zod.number().gt(updateGuestCheckoutDetailsBodyRecoveryHoursExclusiveMin).optional(),
  "insurancePackageId": zod.number().min(1).optional(),
  "occasion": zod.string().max(updateGuestCheckoutDetailsBodyRecoveryOccasionMax).regex(updateGuestCheckoutDetailsBodyRecoveryOccasionRegExp).optional()
}).optional().describe('Saved booking selections for transactional checkout recovery. Never grants access to an existing account or changes marketing consent.'),
  "flowId": zod.string().uuid(),
  "firstName": zod.string().min(1).max(updateGuestCheckoutDetailsBodyFirstNameMax),
  "lastName": zod.string().min(1).max(updateGuestCheckoutDetailsBodyLastNameMax),
  "email": zod.string().email(),
  "turnstileToken": zod.string().nullish().describe('Single-use bot-protection proof when the existing auth protection is enabled. Never stored with guest details.')
})

export const UpdateGuestCheckoutDetailsResponse = zod.unknown()


/**
 * Same-origin, bot-protected and rate-limited. Requires cookie-bound CSRF for edits. Creates no Auth account, SDK session, payment, booking or hold and never looks up an existing account by email.
 * @summary Save private checkout contact details and activate transactional recovery
 */
export const SaveGuestCheckoutDraftHeader = zod.object({
  "X-Checkout-Guest-CSRF": zod.string().optional()
})


export const saveGuestCheckoutDraftBodyOneRecoveryHoursExclusiveMin = 0;


export const saveGuestCheckoutDraftBodyOneRecoveryOccasionMax = 64;


export const saveGuestCheckoutDraftBodyOneRecoveryOccasionRegExp = new RegExp('^[a-zA-Z0-9_-]+$');
export const saveGuestCheckoutDraftBodyOneFirstNameMax = 100;

export const saveGuestCheckoutDraftBodyOneLastNameMax = 100;


export const saveGuestCheckoutDraftBodyTwoRecoveryHoursExclusiveMin = 0;


export const saveGuestCheckoutDraftBodyTwoRecoveryOccasionMax = 64;


export const saveGuestCheckoutDraftBodyTwoRecoveryOccasionRegExp = new RegExp('^[a-zA-Z0-9_-]+$');


export const SaveGuestCheckoutDraftBody = zod.object({
  "recovery": zod.object({
  "carId": zod.number().min(1),
  "dateFrom": zod.coerce.date(),
  "dateTo": zod.coerce.date(),
  "rentalType": zod.enum(['driving', 'chauffeured', 'event']),
  "hours": zod.number().gt(saveGuestCheckoutDraftBodyOneRecoveryHoursExclusiveMin).optional(),
  "insurancePackageId": zod.number().min(1).optional(),
  "occasion": zod.string().max(saveGuestCheckoutDraftBodyOneRecoveryOccasionMax).regex(saveGuestCheckoutDraftBodyOneRecoveryOccasionRegExp).optional()
}).describe('Saved booking selections for transactional checkout recovery. Never grants access to an existing account or changes marketing consent.'),
  "flowId": zod.string().uuid(),
  "firstName": zod.string().min(1).max(saveGuestCheckoutDraftBodyOneFirstNameMax),
  "lastName": zod.string().min(1).max(saveGuestCheckoutDraftBodyOneLastNameMax),
  "email": zod.string().email(),
  "turnstileToken": zod.string().nullish().describe('Single-use bot-protection proof when the existing auth protection is enabled. Never stored with guest details.')
}).and(zod.object({
  "recovery": zod.object({
  "carId": zod.number().min(1),
  "dateFrom": zod.coerce.date(),
  "dateTo": zod.coerce.date(),
  "rentalType": zod.enum(['driving', 'chauffeured', 'event']),
  "hours": zod.number().gt(saveGuestCheckoutDraftBodyTwoRecoveryHoursExclusiveMin).optional(),
  "insurancePackageId": zod.number().min(1).optional(),
  "occasion": zod.string().max(saveGuestCheckoutDraftBodyTwoRecoveryOccasionMax).regex(saveGuestCheckoutDraftBodyTwoRecoveryOccasionRegExp).optional()
}).describe('Saved booking selections for transactional checkout recovery. Never grants access to an existing account or changes marketing consent.')
}))

export const SaveGuestCheckoutDraftResponse = zod.object({
  "guest": zod.object({
  "id": zod.string().uuid(),
  "flowId": zod.string().uuid(),
  "userId": zod.number(),
  "email": zod.string().email(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "createdAt": zod.coerce.date().optional(),
  "expiresAt": zod.coerce.date().optional(),
  "claimed": zod.boolean(),
  "csrfToken": zod.string()
})
})


/**
 * @summary Revoke this browser's guest capability
 */
export const EndGuestCheckoutHeader = zod.object({
  "X-Checkout-Guest-CSRF": zod.string().optional().describe('Required when a guest cookie is present; obtained only from the cookie-owned details response.')
})

export const EndGuestCheckoutResponse = zod.unknown()


/**
 * Requires a genuine verified account, its matching booking contact email and the guest cookie. Does not merge accounts or transfer payments.
 * @summary Associate an email-proven account with its guest booking
 */
export const ClaimGuestCheckoutHeader = zod.object({
  "X-Checkout-Guest-CSRF": zod.string().optional().describe('Required when a guest cookie is present; obtained only from the cookie-owned details response.')
})

export const ClaimGuestCheckoutResponse = zod.object({
  "ok": zod.boolean(),
  "claimedNow": zod.boolean().describe('True only for the first committed email-proven claim')
})


/**
 * @summary List only guest bookings owned by the authenticated payer or proven claimant
 */
export const GetGuestCheckoutBookingsResponse = zod.object({
  "bookings": zod.array(zod.object({
  "public_id": zod.string(),
  "status": zod.union([zod.string(),zod.number()]).optional()
}))
})


/**
 * The delegated session is bound to the requesting account's current provider session. It cannot access stored cards, account changes or initialise another checkout.
 * @summary Obtain booking-only access after genuine account ownership proof
 */
export const AccessGuestBookingBody = zod.object({
  "publicId": zod.string()
})

export const AccessGuestBookingResponse = zod.object({
  "session": zod.object({
  "access_token": zod.string(),
  "refresh_token": zod.string(),
  "token_type": zod.string(),
  "expires_in": zod.number(),
  "expires_at": zod.number().optional(),
  "user": zod.record(zod.string(), zod.unknown())
}).describe('Provider session material for the SDK only. Never persist in checkout drafts, URLs, logs or analytics.'),
  "userId": zod.number()
})


/**
 * Returns the current authenticated user. Both the web app and the mobile app rely on this exact shape.
 * @summary Get the authenticated user
 */
export const GetAuthMeResponse = zod.object({
  "user": zod.object({
  "id": zod.union([zod.string(),zod.number()]).describe('Stable user id (string in the new API, integer in legacy responses).'),
  "email": zod.string().nullish(),
  "first_name": zod.string().nullish(),
  "last_name": zod.string().nullish(),
  "email_verified": zod.boolean().optional(),
  "phone_verified": zod.boolean().optional()
})
})


/**
 * Hero-card payload surfaced on the homepage and the mobile app's "discover" tab.
 * @summary List featured cars
 */
export const ListFeaturedCarsResponse = zod.object({
  "cars": zod.array(zod.object({
  "id": zod.union([zod.string(),zod.number()]),
  "make": zod.string().nullish(),
  "model": zod.string().nullish(),
  "year": zod.number().nullish(),
  "price_driving": zod.number().nullish(),
  "currency": zod.string().nullish(),
  "photo_url": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "country_code": zod.string().nullish()
}))
})


/**
 * Returns up to five active, pictured cars ranked by non-cancelled confirmed or completed bookings in the past 12 months. When both coordinates are supplied, the search progressively widens nearby within the requested country. When both are omitted, results are ranked across that country. A single coordinate is invalid.
 * @summary List the most-booked nearby or country-scoped cars
 */
export const listMostBookedNearbyCarsQueryLatMin = -90;
export const listMostBookedNearbyCarsQueryLatMax = 90;

export const listMostBookedNearbyCarsQueryLngMin = -180;
export const listMostBookedNearbyCarsQueryLngMax = 180;

export const listMostBookedNearbyCarsQueryCountryRegExp = new RegExp('^[A-Za-z]{2}$');


export const ListMostBookedNearbyCarsQueryParams = zod.object({
  "lat": zod.coerce.number().min(listMostBookedNearbyCarsQueryLatMin).max(listMostBookedNearbyCarsQueryLatMax).optional(),
  "lng": zod.coerce.number().min(listMostBookedNearbyCarsQueryLngMin).max(listMostBookedNearbyCarsQueryLngMax).optional(),
  "country": zod.coerce.string().regex(listMostBookedNearbyCarsQueryCountryRegExp)
})

export const ListMostBookedNearbyCarsResponse = zod.object({
  "cars": zod.array(zod.object({
  "id": zod.union([zod.string(),zod.number()]),
  "make": zod.string().nullish(),
  "model": zod.string().nullish(),
  "year": zod.number().nullish(),
  "price_driving": zod.number().nullish(),
  "currency": zod.string().nullish(),
  "photo_url": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "country_code": zod.string().nullish()
}))
})


/**
 * Brand-picker source. Used by the listing wizard and the search filters on both surfaces.
 * @summary List car makes
 */
export const ListCarMakesResponse = zod.object({
  "makes": zod.array(zod.string())
})


/**
 * Returns the full active car inventory grouped by make, for use as a fallback make-picker source.
 * @summary List active car counts by make
 */
export const ListActiveCarMakeCountsResponse = zod.object({
  "makeCounts": zod.array(zod.object({
  "make": zod.string(),
  "count": zod.number()
}))
})


/**
 * Vehicle classification taxonomy (sports, coupe, convertible, …).
 * @summary List car types
 */
export const ListCarTypesResponse = zod.object({
  "types": zod.array(zod.object({
  "id": zod.union([zod.string(),zod.number()]),
  "name": zod.string(),
  "slug": zod.string().optional()
}))
})


/**
 * Search results surfaced by both the web search page and the mobile search tab.
 * @summary Search cars
 */
export const searchCarsQueryPageSizeMax = 48;


export const searchCarsQueryColourIdMax = 100;



export const SearchCarsQueryParams = zod.object({
  "q": zod.coerce.string().optional(),
  "pageSize": zod.coerce.number().min(1).max(searchCarsQueryPageSizeMax).optional(),
  "page": zod.coerce.number().optional(),
  "colour_id": zod.array(zod.coerce.number().min(1)).max(searchCarsQueryColourIdMax).optional().describe('OR-selected car colour IDs; repeat the parameter for multiple colours.')
})

export const SearchCarsResponse = zod.object({
  "cars": zod.array(zod.object({
  "id": zod.union([zod.string(),zod.number()]),
  "make": zod.string().nullish(),
  "model": zod.string().nullish(),
  "year": zod.number().nullish(),
  "price_driving": zod.number().nullish(),
  "currency": zod.string().nullish(),
  "photo_url": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "country_code": zod.string().nullish()
})),
  "total": zod.number().optional(),
  "page": zod.number().optional(),
  "pageSize": zod.number().optional()
})


/**
 * New bookings must use payment-first checkout. This endpoint never creates a trip or payment.
 * @deprecated
 * @summary Retired trip-first checkout
 */
export const RejectRetiredBookingCheckoutResponse = zod.void()


/**
 * Trip list shown on both the web "Trips" page and the mobile "Trips" tab.
 * @summary List the authenticated user's bookings
 */
export const ListBookingsResponse = zod.object({
  "bookings": zod.array(zod.object({
  "id": zod.union([zod.string(),zod.number()]),
  "public_id": zod.string().optional(),
  "status": zod.string(),
  "car_id": zod.union([zod.string(),zod.number()]).optional(),
  "date_from": zod.string().optional(),
  "date_to": zod.string().optional(),
  "total_price": zod.number().optional(),
  "currency": zod.string().optional()
}))
})


/**
 * Inbox conversations surfaced by both the web messages page and the mobile messages tab.
 * @summary List conversations
 */
export const ListMessagesResponse = zod.object({
  "conversations": zod.array(zod.object({
  "id": zod.union([zod.string(),zod.number()]),
  "last_message": zod.string().nullish(),
  "updated_at": zod.string().nullish(),
  "unread_count": zod.number().optional(),
  "other_user": zod.object({
  "id": zod.union([zod.string(),zod.number()]),
  "name": zod.string().nullish()
}).optional()
}))
})


/**
 * @summary Read the host-only originating pending-request financial snapshot
 */
export const GetInitialRequestFinancialSnapshotParams = zod.object({
  "tripId": zod.coerce.number()
})

export const GetInitialRequestFinancialSnapshotResponse = zod.object({
  "snapshot": zod.record(zod.string(), zod.unknown()).nullable()
})


/**
 * Fetches active public descriptions or published car reviews. Arbitrary caller text and private content are not accepted.
 * @summary Translate authorized public listing content by identifier
 */

export const translatePublicListingContentBodyReviewIdOneMultipleOf = 1;



export const TranslatePublicListingContentBody = zod.object({
  "kind": zod.enum(['description', 'history', 'review']),
  "carId": zod.number().min(1),
  "reviewId": zod.union([zod.number().min(1).multipleOf(translatePublicListingContentBodyReviewIdOneMultipleOf),zod.string().uuid()]).optional(),
  "targetLanguage": zod.enum(['en-US', 'en-GB', 'fr', 'de', 'es', 'it', 'nl', 'da', 'sv', 'no'])
})

export const TranslatePublicListingContentResponse = zod.object({
  "text": zod.string(),
  "sourceLanguage": zod.string().nullable(),
  "targetLanguage": zod.string(),
  "alreadyTarget": zod.boolean(),
  "outcome": zod.enum(['translated', 'already_target', 'unchanged']),
  "contentVersion": zod.string()
})





export const GetSavedCarOfferConsentParams = zod.object({
  "carId": zod.coerce.number().min(1)
})

export const GetSavedCarOfferConsentResponse = zod.object({
  "consentId": zod.string().uuid().nullable(),
  "ownerId": zod.number().nullable(),
  "active": zod.boolean(),
  "disclosureVersion": zod.string().nullable()
})





export const SetSavedCarOfferConsentParams = zod.object({
  "carId": zod.coerce.number().min(1)
})

export const setSavedCarOfferConsentBodyExpectedOwnerIdMultipleOf = 1;



export const SetSavedCarOfferConsentBody = zod.object({
  "active": zod.boolean(),
  "disclosureVersion": zod.enum(['saved-car-offers-v1']),
  "expectedOwnerId": zod.number().min(1).multipleOf(setSavedCarOfferConsentBodyExpectedOwnerIdMultipleOf).optional().describe('Required when granting; rejects an ownership change after disclosure')
})

export const SetSavedCarOfferConsentResponse = zod.object({
  "consentId": zod.string().uuid().nullable(),
  "ownerId": zod.number().nullable(),
  "active": zod.boolean(),
  "disclosureVersion": zod.string().nullable()
})





export const RevokeSavedCarOfferConsentParams = zod.object({
  "carId": zod.coerce.number().min(1)
})

export const RevokeSavedCarOfferConsentResponse = zod.object({
  "consentId": zod.string().uuid().nullable(),
  "ownerId": zod.number().nullable(),
  "active": zod.boolean(),
  "disclosureVersion": zod.string().nullable()
})


export const listSavedCarOfferInterestsQueryOffsetMin = 0;
export const listSavedCarOfferInterestsQueryOffsetMax = 10000;

export const listSavedCarOfferInterestsQueryLimitMax = 50;



export const ListSavedCarOfferInterestsQueryParams = zod.object({
  "offset": zod.coerce.number().min(listSavedCarOfferInterestsQueryOffsetMin).max(listSavedCarOfferInterestsQueryOffsetMax).optional(),
  "limit": zod.coerce.number().min(1).max(listSavedCarOfferInterestsQueryLimitMax).optional()
})

export const ListSavedCarOfferInterestsResponse = zod.object({
  "items": zod.array(zod.object({
  "consentId": zod.string().uuid(),
  "carId": zod.number(),
  "carTitle": zod.string(),
  "grantedAt": zod.coerce.date(),
  "firstName": zod.string().nullable(),
  "lastInitial": zod.string().nullable()
})),
  "nextOffset": zod.number().nullable()
})


export const SendSavedCarOfferParams = zod.object({
  "consentId": zod.coerce.string().uuid()
})

export const sendSavedCarOfferBodyMessageMax = 1000;



export const SendSavedCarOfferBody = zod.object({
  "message": zod.string().min(1).max(sendSavedCarOfferBodyMessageMax),
  "clientMessageId": zod.string().uuid()
})

export const SendSavedCarOfferResponse = zod.object({
  "conversationPublicId": zod.string().uuid(),
  "blocked": zod.boolean().optional(),
  "blocked_reason": zod.string().optional(),
  "deduped": zod.boolean().optional()
})
